import React, { FunctionComponent, ReactNode } from 'react';
import WithDataRecord from 'hoc/WithDataRecord';
import {
  AdminApi,
  AdminInvestmentsListRequest,
  DistributionPlatformWithPlatformType,
  AdminInvestmentList,
  AdminInvestmentsListOrderingEnum,
} from 'api';
import useGoTo from 'hooks/use-go-to';
import { FiltersWrapper } from 'ui/molecules/filtering';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import StudioInvestmentsTable from 'apps/issuer/shared/studio-investments-table';
import { PaginationProps } from 'ui/molecules/pagination';

interface IssuerInvestmentsTableProps extends AdminInvestmentsListRequest {
  campaignId: string;
  forceDataLoad?: boolean;
  setForceDataLoad?: (val: boolean) => void;
  defaultLimit?: number;
  paginationProps?: PaginationProps;
  distributionPlatformDetails: DistributionPlatformWithPlatformType;
}

const IssuerInvestmentsTable: FunctionComponent<IssuerInvestmentsTableProps> = WithDataRecord<
  AdminApi,
  AdminInvestmentList
>(AdminApi)(
  ({ data, ordering, onOrderBy, loading, paginationProps, campaignId }) => {
    const goTo = useGoTo(ISSUER_ROUTES.investmentDetails);

    return (
      <>
        <StudioInvestmentsTable
          loading={loading}
          onOrderBy={onOrderBy}
          ordering={ordering}
          goToDetails={(productId: string, investmentId: string) => goTo({ productId, investmentId })}
          investments={data}
          paginationProps={paginationProps}
          campaignId={campaignId}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.adminInvestmentsList({
      campaign: props.campaignId,
      offset,
      limit,
      ordering: ordering as AdminInvestmentsListOrderingEnum,
      ...props,
    });
  },
);

export default IssuerInvestmentsTable;
